import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/GenericServices/ViewPaymentDetailsGS.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import { store } from '../../../Redux/_helpers/store';
import { Link } from 'react-router-dom';
import { successLoader, } from '../../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { DOCUMENT_ENDPOINT } from '../../../Services/config/apiEndPoints';
class ViewPaymentDetailsGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            quotationId: '201',
            quotationDate: 84782763,
            serviceType: 'Transportation Service',
            orderId: '101',
            orderDate: 78572383794,
            serviceCharge: '150.00',
            transactionFees: '10.00',
            discount: '1.00',
            beforeTaxes: '9.00',
            VAT: '1.35',
            orderTotal: '10.35',
            paymentMethod: 'Credit Card',
            serviceChargePay: false,
            documentURL: utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=",
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            //
        }
    };
    onProceed = () => {
    }
    downloadDocument = (path) => {
        //start loader
        store.dispatch(successLoader(false));
        const testAccess = Cookies.get('_msAL');
        fetch(this.state.documentURL + path, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer' + ` ${testAccess}`,
                'x-cc-trace-id': "123"
            }
        })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                var extensionType = path.substring(path.lastIndexOf(".") + 1, path.length);
                const extensionTypeF = extensionType.replace("')", "");
                a.download = `Invoice.${extensionTypeF}`;
                document.body.appendChild(a);
                a.click();
                //end loader
                store.dispatch(successLoader(true));
                window.URL.revokeObjectURL(url);
            })
            .catch(() => console.log('error'));
    }
    render() {
        return (
            <div class="VPDaymentDOutercolor">
                <MetaDecorator title={TitleDescription.ViewPaymentDetailsGSTitle} description={TitleDescription.ViewPaymentDetailsGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="VPDaymentDOuterDivcss">
                    <div id="VPDaymentDBoxDiv">
                        <nav class="VPDaymentDNavbar">
                            <div className="VPDaymentDNavbarName">
                                <small id="VPDaymentDNavbarText">Payment Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="VPDaymentDMidPartition">
                            <div class="VPDmscarddiv2">
                                <div class="VPDpspsubhisdiv">
                                    <small class="VPDmscarddivsm1">Service Request Details</small>
                                </div>
                                <div>
                                    <div class="VPDpspmscardactive1order">
                                        <div class="VPDpddivout1">
                                            <div class="VPDpdconerow">
                                                <small class="VPDpddivsm1">Service Request ID</small>
                                                <small class="VPDpddivsm2">{this.state.quotationId}</small>
                                            </div>
                                            <div class="VPDpdconerow">
                                                <small class="VPDpddivsm1" id='VDPquotationLable'>Service Request Date & Time</small>
                                                <small class="VPDpddivsm2" id='VDPquotationValue'>{FormatTimeStamp(this.state.quotationDate).timedateToLocale}</small>
                                            </div>
                                            <div class="VPDpdconerow">
                                                <small class="VPDpddivsm1">Service type</small>
                                                <small class="VPDpddivsm2" id='VDPquotationValue'>{this.state.serviceType}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="VPDmscarddiv2">
                                <div class="VPDpdsubhisdiv">
                                    <small class="VPDmscarddivsm1">Order Summary</small>
                                </div>
                                <div class="VPDaymentDCardCss">
                                    <div class="VPDaymentDCardInner">
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Order ID</small>
                                            <small class="VPDaymentDCardTextRight">{this.state.orderId}</small>
                                        </div>
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Order Date & Time</small>
                                            <small class="VPDaymentDCardTextRight">{FormatTimeStamp(this.state.orderDate).timedateToLocale}</small>
                                        </div>
                                    </div>
                                    <div class="VPDaymentDCardInner">
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Service Charge</small>
                                            {this.state.serviceChargePay ?
                                                <small class="VPDaymentDCardOrderRight">R {this.state.serviceCharge}</small>
                                                :
                                                <small class="VPDaymentDCardOrderRight">NA*</small>
                                            }
                                        </div>
                                    </div>
                                    <div class="VPDaymentDCardInner">
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Transaction Fees</small>
                                            <small class="VPDaymentDCardTextRight">R {this.state.transactionFees}</small>
                                        </div>
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Discount (10%)</small>
                                            <small class="VPDaymentDCardTextRight">R {this.state.discount}</small>
                                        </div>
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">Before Taxes</small>
                                            <small class="VPDaymentDCardTextRight">R {this.state.beforeTaxes}</small>
                                        </div>
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardTextLeft">VAT (15%)</small>
                                            <small class="VPDaymentDCardTextRight">R {this.state.VAT}</small>
                                        </div>
                                    </div>
                                    <div class="VPDaymentDCardOrder">
                                        <div class="VPDaymentDCardRow">
                                            <small class="VPDaymentDCardOrderLeft">Order Total</small>
                                            <small class="VPDaymentDCardOrderRight">R {this.state.orderTotal}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="VPDmscarddiv2">
                                <div class="VPDpdsubhisdiv">
                                    <small class="VPDmscarddivsm1">Payment Information</small>
                                </div>
                                <div>
                                    <div class="VPDpdmscardactive1">
                                        <div class="VPDpdconerow">
                                            <small class="VPDpddivsm1">Payment Method</small>
                                            <small class="VPDpddivsm2">{this.state.paymentMethod}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='VPDdownloadDiv'>
                                <div class="VPDpdmscardactive1">
                                    <div class="VPDpdconerow">
                                        <small class="VPDpddivsm2">Download Invoice</small>
                                        <small class="VPDpddivsm2">
                                            <Link onClick={() => this.downloadDocument('pdfPath')}>
                                                <img
                                                    src={download}
                                                    class="" id=""
                                                    alt="" loading="lazy"
                                                />
                                            </Link>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            {!this.state.serviceChargePay &&
                                <div class='VPDserviceChargeDiv'>*
                                <small class="VPDserviceChargeLeft"> Service Charge </small>
                                    <small class='VPDserviceChargeRight'>to be settled directly with Respondent in accordance with the agreed payment terms stipulated on the service response.</small>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="VPDaymentDFooterUnfixed">
                    <Footer />
                </div>
                <div class="VPDaymentDFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default ViewPaymentDetailsGS;